__turbopack_context__.v({
  "companyName": "dpTRfW_companyName",
  "email": "dpTRfW_email",
  "name": "dpTRfW_name",
  "popper": "dpTRfW_popper",
  "suggestion": "dpTRfW_suggestion",
});
